import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MetafieldsService } from 'src/app/services/metafields.service';
declare var $: any;
@Component({
  selector: 'app-home-new-update',
  templateUrl: './home-new-update.component.html',
  styleUrls: ['./home-new-update.component.scss']
})
export class HomeNewUpdateComponent implements OnInit {

  
    count = 200;
    duration = 2000;
  

  slideOpts = {
        breakpoints:{

        320:{
          slidesPerView:1,

        },
        556: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        640: {
          slidesPerView: 1.5,
          spaceBetween: 40
          
        },
        2500:{
          slidesPerView: 2.5
        }
      },
    // slidesPerView: 2.5,
    
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
     
      modifier: 1,
      
      slideShadows: true,
  
    },
    loop: true,
    autoplay:true,
    centeredSlides: true,
    

  }
  

  slides = {
    slidesPerView: 1,
    cubeEffect: {
      shadow: true,
      slideShadows: true,
      shadowOffset: 20,
      shadowScale: 0.94,
    },
    loop: true,
    autoplay:true,
    centeredSlides: true,
    
  }
  
  
  imageslider={
    // slidesPerView:7,
    breakpoints:{

      320:{
        slidesPerView:1.5,

      },
      556: {
        slidesPerView: 2,
        // spaceBetween: 30
      },
      640: {
        slidesPerView: 3,
        // spaceBetween: 40
        
      },
      2500:{
        slidesPerView: 5
      },
    1200:{
        slidesPerView: 4
      }
    },
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
     
      modifier: 1,
      
      slideShadows: true,
      
    },
    loop: true,
    
    autoplay:true,
    centeredSlides: true,
    
    
    
  }

  
  
  // imageObject = [{
  //   // image : 'C:/Users/pc/Desktop/banner......jpg.jpg'
  //   image : 'https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022825131927-901createapp.jpg'
  // }]
  
  constructor( private meta:MetafieldsService ) { 
    this.meta.api.addAndRemoveClass('home','portfolio profilepagesection blog careers contactus services technology getaquote HomeMain blogcontentbody');
  }
  

  ngOnInit(): void {
    // console.log(this.imageObject,'Image')
    this.meta.setMetaFields('Home');
  }

}
